<script>
  import { SPRITESHEET_URL } from '../../utils/constants.ts';
  import { openOverpanel } from '../../stores/overpanelControl.ts';
  
  let {
    editLabelText,
    a11yTemplate,
    form,
    strength,
    quantity,
    dataTestId = 'pricing-drug-details-control',
    closeCallback = () => {},
  } = $props();

  let drugDetailsControl = $state();

  const handleClick = () => {
    openOverpanel('drug', {
      closeCallback: () => {
        closeCallback();
        drugDetailsControl.focus();
      },
    });
  };

  const handlea11yTemplate = (text) =>
    text.replace('{{FORM}}', form).replace('{{STRENGTH}}', strength).replace('{{QUANTITY}}', quantity);
</script>

<button
  aria-label={handlea11yTemplate(a11yTemplate)}
  class="w-full px-4 py-3 justify-center text-blue-cerulean hover-hover:hover:text-blue-darkish group
  focus:relative focus:outline-none active:shadow-inset-active focus:shadow-inset-focus active:text-blue-darkish
  md:py-0 lg:px-0"
  data-testid={dataTestId}
  bind:this={drugDetailsControl}
  onclick={handleClick}
>
  <div class="flex items-center">
    <svg class="fill-current h-6 w-6 lg:h-10 lg:w-10 mr-4 md:hidden" role="presentation">
      <use xlink:href="{SPRITESHEET_URL}#find-drug" />
    </svg>
    <div
      class="w-full flex text-left justify-between items-baseline text-sm leading-normal font-medium md:justify-start lg:text-base"
    >
      <div class="md:font-normal md:text-blue-navy">
        <span data-testid="{dataTestId}-form-label">{form},</span>
        <span data-testid="{dataTestId}-strength-label">{strength},</span>
        <span data-testid="{dataTestId}-quantity-label">{quantity}</span>
      </div>
      <div
        class="ml-2 text-nowrap text-sm font-medium hover-hover:group-hover:underline hover-hover:group-hover:text-blue-navy group-active:underline md:text-blue-cerulean"
      >
        <span class="hidden md:text-blue-navy md:inline md:font-normal">(</span>{editLabelText}<span
          class="hidden md:text-blue-navy md:inline md:font-normal">)</span
        >
      </div>
    </div>
  </div>
</button>
